import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { I18nProvider } from './i18n/I18nProvider'
import { AppProvider } from './store/AppProvider'
import App from './App'
import './index.css'

// When the dev server restarts (or a new build ships) an open tab holds a stale
// module graph; Vite fires this before the dynamic import 404s. Reload once to
// pick up the fresh chunks instead of leaving a blank screen.
window.addEventListener('vite:preloadError', () => {
  const KEY = 'kx:preload-reload'
  const last = Number(sessionStorage.getItem(KEY) || 0)
  if (performance.now() - last > 10000) {
    sessionStorage.setItem(KEY, String(performance.now()))
    window.location.reload()
  }
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <I18nProvider>
        <AppProvider>
          <App />
        </AppProvider>
      </I18nProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
